import { render, staticRenderFns } from "./TestProvocativiList.vue?vue&type=template&id=d18ae674"
import script from "./TestProvocativiList.vue?vue&type=script&lang=js"
export * from "./TestProvocativiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports